// extracted by mini-css-extract-plugin
export default {"InformationButtonContainer":"InformationButton_InformationButtonContainer__OlWW+","Grey":"InformationButton_Grey__xV8wY","White":"InformationButton_White__kNzqv"};